// extracted by mini-css-extract-plugin
module.exports = {"userContainer":"User_userContainer__KMvUL","userData":"User_userData__2KLY-"};